import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, 
         DwContextService, DwOrmDataService, DwOrmDataServiceToken, DwEventService } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AvStarRatingNspTechCountContextService } from '../data-contexts/av-ratings-nsp-tech-count-context.service';
import { SurveysMetaDataService, StarRatingAvProjectsEntity, SurveysMetaDataItemNames } from '../meta-data/surveys-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
import { exp } from 'mathjs';
const moment = moment_;

@DwComponent({
  name: 'Av Star Ratings UI Util',
  key: 'avStarRatingsUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: SurveysMetaDataItemNames.StarRatingAvProjects,
})
@Component({
  selector: 'av-star-ratings-ui-util',
  template: ` 
  `
})
export class AvRatingsUiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
    formApi: DwMetaDataFormApi;
    constructor(
        dwExpressionService: DwExpressionService,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        private dwEventService: DwEventService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private dwContextService: DwContextService,
        private dwFormStateService: DwMetaDataFormStateService
    ) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.formApi = this.dwFormStateService.state.formApi;
    }
    ngOnInit(): void {
    }

    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => this.postInitSetup());
    }

    private postInitSetup() {
        const avRatings = this.formApi.getFormData<StarRatingAvProjectsEntity>();
        this.subscriptions.push(this.formApi.getFormDataChanges<StarRatingAvProjectsEntity>().subscribe(entity => {
            this.handleUpdate(entity);
        }));

        this.dwContextService.getContextsAndResolve([AvStarRatingNspTechCountContextService.ContextName], 
                                                    { data: avRatings, formApi: this.formApi })
            .subscribe(cxt => { });

    }
    ngOnDestroy(): void {
        for(const subscription of this.subscriptions) {
        subscription.unsubscribe();
        }
    }

    nspInstallUserId : number = null;
    UPDATE_TOPIC = 'UPDATE-RATING-';
    handleUpdate(data: StarRatingAvProjectsEntity) { 
        if (data.NspInstallTechScore != undefined && this.nspInstallUserId != undefined && 
            data.NspInstallTechnicianUserId == undefined){
            this.formApi.patchFormData({ NspInstallTechScore: 0 });
            this.dwEventService.publishEvent(this.UPDATE_TOPIC + 'NspInstallTechScore', 0);
       }
        this.nspInstallUserId = data.NspInstallTechnicianUserId;
    }
}
